import * as allCommands from '../commands';

export const help = async (args: string[]): Promise<string> => {
  const commands = Object.keys(allCommands).sort().join(', ');
  return `Available commands:
    
    ${commands}
    
    [tab]    trigger completion.
    [ctrl+l] clear terminal.
    [ctrl+c] cancel command.`;
};
